(function () {
  var selector = '[data-drpen-card-orbit]';
  var desktopQuery = window.matchMedia('(min-width: 750px)');
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalize180(value) {
    return ((value + 180) % 360 + 360) % 360 - 180;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function easeOutCubic(value) {
    return 1 - Math.pow(1 - value, 3);
  }

  function addQueryListener(query, callback) {
    if (query.addEventListener) {
      query.addEventListener('change', callback);
      return;
    }

    if (query.addListener) {
      query.addListener(callback);
    }
  }

  function setScene(section) {
    var viewport = section.querySelector('[data-drpen-orbit-viewport]');
    var ring = section.querySelector('[data-drpen-orbit-ring]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-drpen-orbit-card]'));
    if (!viewport || !ring || !cards.length) return;

    if (section.drpenCardOrbitDestroy) section.drpenCardOrbitDestroy();

    var count = cards.length;
    var hold = getNumber(section.dataset.cardHold, 1800);
    var transition = getNumber(section.dataset.cardTransition, 900);
    var tiltAmount = getNumber(section.dataset.tiltAmount, 100) / 100;
    var parallaxAmount = getNumber(section.dataset.parallaxAmount, 100) / 100;
    var configuredRadius = getNumber(section.dataset.orbitRadius, 260);
    var idleSpinSpeed = getNumber(section.dataset.idleSpinSpeed, 12) / 100;
    var step = 360 / count;
    var radius = Math.min(620, Math.max(180, configuredRadius || 260));
    var rotationDeg = 0;
    var mobileActiveIndex = 0;
    var mobileDragOffset = 0;
    var tiltXDeg = 0;
    var tiltYDeg = 0;
    var isPointerDown = false;
    var isDragging = false;
    var activePointerId = null;
    var lastPointerX = 0;
    var dragDistance = 0;
    var pointerStartX = 0;
    var pendingLink = null;
    var suppressClick = false;
    var rafId = null;
    var mobileRafId = null;
    var lastTime = 0;
    var enabled = desktopQuery.matches && !reducedQuery.matches;
    var mobileEnabled = mobileQuery.matches;

    section.style.setProperty('--drpen-orbit-count', count);
    section.style.setProperty('--drpen-orbit-radius', radius + 'px');
    section.style.setProperty('--drpen-orbit-transition', '0ms');
    section.style.setProperty('--drpen-orbit-rotation', '0deg');
    section.style.setProperty('--drpen-orbit-counter-rotation', '0deg');
    section.style.setProperty('--drpen-orbit-tilt-x', '0deg');
    section.style.setProperty('--drpen-orbit-tilt-y', '0deg');
    section.style.setProperty('--drpen-orbit-shift-x', '0px');
    section.style.setProperty('--drpen-orbit-shift-y', '0px');

    cards.forEach(function (card, index) {
      var angle = step * index;
      card.dataset.orbitAngle = angle;
      card.style.setProperty('--card-index', index);
      card.style.setProperty('--card-angle', angle + 'deg');
      card.style.setProperty('--card-angle-inverse', -angle + 'deg');
    });

    function updateCards() {
      var activeIndex = 0;
      var activeDistance = 999;

      cards.forEach(function (card, index) {
        var angle = parseFloat(card.dataset.orbitAngle || '0');
        var relative = normalize180(rotationDeg + angle);
        var distance = Math.abs(relative);
        var depth = Math.cos(relative * Math.PI / 180);

        if (distance < activeDistance) {
          activeDistance = distance;
          activeIndex = index;
        }

        card.classList.remove('is-showing-back');
        card.style.setProperty('--card-depth', depth.toFixed(3));
        card.style.setProperty('--card-brightness', (0.68 + Math.max(depth, 0) * 0.28).toFixed(3));
      });

      cards.forEach(function (card, index) {
        var distanceFromActive = Math.abs(index - activeIndex);
        distanceFromActive = Math.min(distanceFromActive, count - distanceFromActive);

        card.classList.toggle('is-active', index === activeIndex);
        card.classList.toggle('is-near', distanceFromActive === 1);
      });

      return activeDistance;
    }

    function render() {
      ring.style.transform = [
        'translate3d(-50%, -50%, 0)',
        'rotateX(' + tiltXDeg.toFixed(3) + 'deg)',
        'rotateY(' + (rotationDeg + tiltYDeg).toFixed(3) + 'deg)'
      ].join(' ');
      section.style.setProperty('--drpen-orbit-rotation', rotationDeg.toFixed(3) + 'deg');
      section.style.setProperty('--drpen-orbit-counter-rotation', (-rotationDeg).toFixed(3) + 'deg');
      section.style.setProperty('--drpen-orbit-tilt-x', tiltXDeg.toFixed(3) + 'deg');
      section.style.setProperty('--drpen-orbit-tilt-y', tiltYDeg.toFixed(3) + 'deg');
    }

    function clearMobileCards() {
      section.dataset.mobileOrbit3d = 'false';
      mobileDragOffset = 0;
      cards.forEach(function (card) {
        card.style.zIndex = '';
        card.style.opacity = '';
        card.style.filter = '';
        card.style.transform = '';
      });
    }

    function updateMobileCards() {
      mobileRafId = null;
      mobileEnabled = mobileQuery.matches;

      if (!mobileEnabled) {
        clearMobileCards();
        return;
      }

      section.dataset.mobileOrbit3d = 'true';

      cards.forEach(function (card, index) {
        var rawOffset = index - mobileActiveIndex + mobileDragOffset;
        var progress = clamp(rawOffset, -2, 2);
        var distance = Math.abs(progress);
        var visibleDistance = Math.min(distance, 1.6);
        var rotateY = progress * -48;
        var translateX = progress * 11.4;
        var translateZ = 10 - visibleDistance * 16;
        var translateY = visibleDistance * 0.6;
        var scale = 1 - Math.min(distance, 1) * 0.13;
        var opacity = distance > 1.65 ? 0 : 1;
        var brightness = 1 - Math.min(distance, 1) * 0.06;

        card.classList.remove('is-showing-back');
        card.style.zIndex = String(Math.round(100 - distance * 10));
        card.style.opacity = opacity.toFixed(3);
        card.style.filter = 'brightness(' + brightness.toFixed(3) + ')';
        card.style.transform = [
          'translate3d(calc(-50% + ' + translateX.toFixed(3) + 'rem), ' + translateY.toFixed(3) + 'rem, ' + translateZ.toFixed(3) + 'rem)',
          'rotateY(' + rotateY.toFixed(3) + 'deg)',
          'scale(' + scale.toFixed(3) + ')'
        ].join(' ');
        card.classList.toggle('is-active', index === mobileActiveIndex);
        card.classList.toggle('is-near', distance === 1);
      });
    }

    function requestMobileUpdate() {
      if (mobileRafId) return;
      mobileRafId = window.requestAnimationFrame(updateMobileCards);
    }

    function tick(now) {
      if (!enabled) return;

      if (!lastTime) lastTime = now;
      var delta = Math.min(now - lastTime, 40);
      lastTime = now;

      var activeDistance = updateCards();
      var pauseZone = Math.max(12, step * 0.32);
      var moveFactor = easeOutCubic(Math.min(activeDistance / pauseZone, 1));
      var slowSpeed = step / Math.max(hold, 900);
      var fastSpeed = step / Math.max(transition, 420);
      var speedScale = idleSpinSpeed > 0 ? idleSpinSpeed / 0.12 : 0;
      var speed = (slowSpeed + (fastSpeed - slowSpeed) * moveFactor) * speedScale;

      if (!isDragging) {
        rotationDeg -= speed * delta;
      }
      render();

      rafId = window.requestAnimationFrame(tick);
    }

    function start() {
      stop();
      enabled = desktopQuery.matches && !reducedQuery.matches;
      mobileEnabled = mobileQuery.matches;

      if (!enabled) {
        rotationDeg = 0;
        tiltXDeg = 0;
        tiltYDeg = 0;
        isPointerDown = false;
        isDragging = false;
        activePointerId = null;
        updateCards();
        render();
        requestMobileUpdate();
        return;
      }

      clearMobileCards();
      lastTime = 0;
      rafId = window.requestAnimationFrame(tick);
    }

    function stop() {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }

      if (mobileRafId) {
        window.cancelAnimationFrame(mobileRafId);
        mobileRafId = null;
      }
    }

    function handlePointerMove(event) {
      if (mobileEnabled) {
        if (!isPointerDown || event.pointerId !== activePointerId) return;

        var mobileDeltaX = event.clientX - pointerStartX;
        lastPointerX = event.clientX;
        dragDistance = Math.abs(mobileDeltaX);

        if (dragDistance > 3) {
          isDragging = true;
          section.dataset.dragging = 'true';
        }

        mobileDragOffset = clamp(-mobileDeltaX / Math.max(viewport.clientWidth * 0.42, 1), -1, 1);
        requestMobileUpdate();
        return;
      }

      if (!enabled) return;
      var rect = viewport.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width - 0.5;
      var y = (event.clientY - rect.top) / rect.height - 0.5;
      var shiftX = x * 18 * parallaxAmount;
      var shiftY = y * 12 * parallaxAmount;

      tiltXDeg = parseFloat((y * -10 * tiltAmount).toFixed(2));
      tiltYDeg = parseFloat((x * 8 * tiltAmount).toFixed(2));
      section.style.setProperty('--drpen-orbit-shift-x', shiftX.toFixed(2) + 'px');
      section.style.setProperty('--drpen-orbit-shift-y', shiftY.toFixed(2) + 'px');

      if (isPointerDown && event.pointerId === activePointerId) {
        var deltaX = event.clientX - lastPointerX;
        lastPointerX = event.clientX;
        dragDistance += Math.abs(deltaX);

        if (dragDistance > 3) {
          isDragging = true;
          section.dataset.dragging = 'true';
        }

        if (deltaX !== 0) {
          rotationDeg += deltaX * 0.36;
          updateCards();
        }
      }

      render();
    }

    function handlePointerDown(event) {
      if ((!enabled && !mobileEnabled) || event.button > 0) return;
      isPointerDown = true;
      isDragging = false;
      activePointerId = event.pointerId;
      lastPointerX = event.clientX;
      pointerStartX = event.clientX;
      dragDistance = 0;
      pendingLink = event.target.closest ? event.target.closest('[data-drpen-orbit-link]') : null;
      if (pendingLink && !viewport.contains(pendingLink)) pendingLink = null;
      section.dataset.dragging = 'false';

      if (viewport.setPointerCapture) {
        viewport.setPointerCapture(event.pointerId);
      }
    }

    function handlePointerUp(event) {
      if (!isPointerDown || event.pointerId !== activePointerId) return;
      isPointerDown = false;
      isDragging = false;
      activePointerId = null;
      section.dataset.dragging = 'false';

      if (viewport.releasePointerCapture) {
        try {
          viewport.releasePointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture may already be released by the browser.
        }
      }

      if (mobileEnabled && dragDistance > 24) {
        var direction = event.clientX < pointerStartX ? 1 : -1;
        mobileActiveIndex = clamp(mobileActiveIndex + direction, 0, count - 1);
        mobileDragOffset = 0;
        requestMobileUpdate();
      } else if (mobileEnabled) {
        mobileDragOffset = 0;
        requestMobileUpdate();
      }

      if (pendingLink && dragDistance <= 6) {
        suppressClick = true;
        window.location.href = pendingLink.href;
      }

      pendingLink = null;
    }

    function resetPointerState() {
      isPointerDown = false;
      isDragging = false;
      activePointerId = null;
      pendingLink = null;
      mobileDragOffset = 0;
      section.dataset.dragging = 'false';
      requestMobileUpdate();
    }

    function handleClick(event) {
      if (suppressClick || dragDistance > 6) {
        event.preventDefault();
        event.stopPropagation();
      }

      suppressClick = false;
      dragDistance = 0;
    }

    function handleLeave() {
      if (isPointerDown) return;
      tiltXDeg = 0;
      tiltYDeg = 0;
      section.style.setProperty('--drpen-orbit-shift-x', '0px');
      section.style.setProperty('--drpen-orbit-shift-y', '0px');
      render();
    }

    viewport.addEventListener('pointerdown', handlePointerDown);
    viewport.addEventListener('pointermove', handlePointerMove);
    viewport.addEventListener('pointerup', handlePointerUp);
    viewport.addEventListener('pointercancel', handlePointerUp);
    viewport.addEventListener('pointerleave', handleLeave);
    viewport.addEventListener('click', handleClick, true);
    ring.addEventListener('scroll', requestMobileUpdate, { passive: true });
    window.addEventListener('resize', requestMobileUpdate);
    window.addEventListener('pointerup', resetPointerState);
    window.addEventListener('blur', resetPointerState);

    updateCards();
    render();
    start();

    section.drpenCardOrbitDestroy = function () {
      stop();
      viewport.removeEventListener('pointerdown', handlePointerDown);
      viewport.removeEventListener('pointermove', handlePointerMove);
      viewport.removeEventListener('pointerup', handlePointerUp);
      viewport.removeEventListener('pointercancel', handlePointerUp);
      viewport.removeEventListener('pointerleave', handleLeave);
      viewport.removeEventListener('click', handleClick, true);
      ring.removeEventListener('scroll', requestMobileUpdate);
      window.removeEventListener('resize', requestMobileUpdate);
      window.removeEventListener('pointerup', resetPointerState);
      window.removeEventListener('blur', resetPointerState);
      tiltXDeg = 0;
      tiltYDeg = 0;
      isPointerDown = false;
      isDragging = false;
      activePointerId = null;
      dragDistance = 0;
      pendingLink = null;
      suppressClick = false;
      section.dataset.dragging = 'false';
      section.style.setProperty('--drpen-orbit-shift-x', '0px');
      section.style.setProperty('--drpen-orbit-shift-y', '0px');
      clearMobileCards();
      render();
    };
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(selector).forEach(setScene);
  }

  window.DrpenCardOrbitShowcaseInit = initAll;

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(selector).forEach(function (section) {
      if (section.drpenCardOrbitDestroy) section.drpenCardOrbitDestroy();
    });
  });

  addQueryListener(desktopQuery, function () {
    initAll(document);
  });
  addQueryListener(mobileQuery, function () {
    initAll(document);
  });
  addQueryListener(reducedQuery, function () {
    initAll(document);
  });
})();
